module.exports = __webpack_public_path__ + "56fdeca0fa3e8dac82f387212adaf700.svg";